import { unicodeRegexp } from '@/utils/string/types'

export const isUnicode = (text: string): boolean => new RegExp(unicodeRegexp, 'giu').test(text)
